<script setup lang="ts">
  import { computed } from 'vue'
  // Postal/visit/billing address sections share the header +
  // DataContainerAddress + edit-button shell; explicit per-section markup is
  // preferred over a data-driven wrapper. See feedback_primitives_over_wrappers.
  // fallow-ignore-next-line code-duplication
  import { testIds } from '@gat-ship/types'
  import { text } from '@gat-ship/stakeholders'
  import { IconLoading } from '@gat-ship/icons'
  import {
    ModalSection,
    ModalSectionHeader,
    ModalSectionHeaderTitle,
    Button
  } from '@gat-ship/vue-components'
  import { DataContainerAddress } from '@gat-ship/ref-data'
  import { useStakeholderContext } from '../../../composables/useStakeholder'
  import { useStakeholderModals } from '../../providers/stakeholder-modals'
  import {
    useStakeholderEditAction,
    type StakeholderEditButtonConfig
  } from '../../../composables/useStakeholderEditAction'
  // fallow-ignore-next-line code-duplication
  const service = useStakeholderContext()
  const modals = useStakeholderModals()

  const stakeholder = computed(() => service?.stakeholder.value)

  const { isLoading, canShow, btnConfig } = useStakeholderEditAction(
    () => stakeholder.value,
    () =>
      text.groups.postalAddress(stakeholder.value?.stakeholderType ?? 'client')
        .buttons.changePostalAddress as StakeholderEditButtonConfig
  )
</script>

<template>
  <ModalSection v-if="stakeholder">
    <ModalSectionHeader>
      <ModalSectionHeaderTitle>
        {{ text.groups.postalAddress(stakeholder.stakeholderType).title }}
      </ModalSectionHeaderTitle>
    </ModalSectionHeader>
    <DataContainerAddress
      :address-test-id="testIds.stakeholder.sections.postalAddress.address"
      :country-name-test-id="testIds.stakeholder.sections.postalAddress.country"
      :data="{
        address: stakeholder.postalAddress ?? undefined
      }"
      no-data-text="No post address."
    />
    <Button
      v-if="canShow"
      :variant="btnConfig.variant"
      :size="btnConfig.size"
      :class="[btnConfig.class, 'w-fit']"
      :disabled="isLoading"
      :data-testid="testIds.stakeholders.actions.changePostAddress"
      @click="modals?.showUpdatePostAddress({ stakeholder })"
    >
      <IconLoading v-if="isLoading" class="size-4 shrink-0" />
      <component
        :is="btnConfig.icon"
        v-else-if="btnConfig.icon"
        class="size-4"
      />
      {{ btnConfig.label }}
    </Button>
  </ModalSection>
</template>
